import { all, call, put, spawn, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import {
  SEARCH_EASY_SPLIT_PAYMENTS_URL,
  SEARCH_PAYMENTS,
  EXPORT_TO_CSV,
  EASY_SPLIT_PAYMENTS_DATA_MAPPER,
} from './constants';
import { savePaymentsAction, disableLoaderAction } from './actions';
import { showToast } from '../Toast/actions';

export function* searchPayments({ data }) {
  try {
    const { options: reqOptions } = data;
    const { url, method } = SEARCH_EASY_SPLIT_PAYMENTS_URL;
    const options = { method, queryString: reqOptions || {} };
    const { data: payments, cursor } = yield call(request, url, options);
    yield put(savePaymentsAction({ data: payments, cursor }));
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function getModifiedEasySplitPaymentsData(responseData) {
  const mapper = EASY_SPLIT_PAYMENTS_DATA_MAPPER;
  let responseArr = [];

  for (let i = 0; i < responseData.length; i += 1) {
    const obj = responseData[i];
    const responseObj = {};
    Object.keys(obj).forEach(item => {
      if (mapper[item]) {
        responseObj[item] = obj[item];
      }
    });
    responseArr = [...responseArr, responseObj];
  }
  return responseArr;
}

export function getHeaderForEasySplitPaymentsData(responseData) {
  const responseArr = Object.keys(responseData[0]);
  const mapper = EASY_SPLIT_PAYMENTS_DATA_MAPPER;
  let headerArr = [];

  responseArr.forEach(item => {
    if (mapper[item]) {
      headerArr = [...headerArr, mapper[item]];
    }
  });
  return headerArr;
}

export function* exportToCSV({ data }) {
  try {
    const { cb, options: reqOptions } = data;
    const { url, method } = SEARCH_EASY_SPLIT_PAYMENTS_URL;
    const options = {
      method,
      queryString: reqOptions || {},
    };
    const response = yield call(request, url, options);
    const modifiedResponseData = getModifiedEasySplitPaymentsData(
      response.data,
    );
    const responseArr = [
      getHeaderForEasySplitPaymentsData(modifiedResponseData),
      ...modifiedResponseData,
    ];
    const filename = 'easysplit-payments.csv';
    cb(filename, responseArr);
    yield put(disableLoaderAction());
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* searchPaymentsSaga() {
  yield takeLatest(SEARCH_PAYMENTS, searchPayments);
}

export function* exportToCSVSaga() {
  yield takeLatest(EXPORT_TO_CSV, exportToCSV);
}
// Individual exports for testing
export default function* easySplitPaymentsSaga() {
  const sagas = [searchPaymentsSaga, exportToCSVSaga];

  yield all(
    sagas.map(saga =>
      // eslint-disable-next-line func-names
      spawn(function*() {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      }),
    ),
  );
}
